import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';

import type { Args as PopupInnerBaseArgs } from 'webapp/components/popup/inner/base';
import PopupInnerBase from 'webapp/components/popup/inner/base';

import type PopupModal from 'webapp/models-custom/popup/modal';

export interface Args extends PopupInnerBaseArgs {
	model: PopupModal;
}

export default abstract class PopupInnerModalComponent<
	TData extends object = PopupData.Any,
> extends PopupInnerBase<Args> {
	declare __popupData: TData; // just for type inference - see types/webapp/common:InferPopupData

	@tracked submitInProgress = false;

	get popupData(): TData {
		return this.args.model.data as TData;
	}
}
